module.exports = __webpack_public_path__ + "assets/img/theme_nemo_thumbnail.0b5feddc.png";